import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1.84229L19 5.92562V11.3271C20.0294 11.7793 20.9266 12.3445 21.6106 13.0141C22.4384 13.8245 23 14.8389 23 16C23 17.9635 21.4342 19.472 19.5183 20.4299C17.5425 21.4178 14.883 22 12 22C9.11699 22 6.45748 21.4178 4.48172 20.4299C2.56577 19.472 1 17.9635 1 16C1 14.8389 1.56155 13.8245 2.38936 13.0141C3.07342 12.3445 3.97057 11.7793 5 11.3271L5 5.92562L12 1.84229ZM5 13.5588C4.50904 13.8362 4.10308 14.1353 3.78841 14.4433C3.22379 14.996 3 15.5255 3 16C3 16.7979 3.67281 17.7894 5.37615 18.6411C7.01967 19.4629 9.36016 20 12 20C14.6398 20 16.9803 19.4629 18.6239 18.6411C20.3272 17.7894 21 16.7979 21 16C21 15.5255 20.7762 14.996 20.2116 14.4433C19.8969 14.1353 19.491 13.8362 19 13.5588V14.0744L12 18.1577L5 14.0744V13.5588ZM11.866 15.759V10.0882L7 7.36469V12.9256L11.866 15.759Z"}}]};

const Map3DFilled = Vue.extend<IconProps>({
  name: 'Map3DFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-3d-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Map3DFilled;
